import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';

import type { CarouselItem, ListContext } from 'renderer/utils/analytics';
import { buildEvent, findItem } from 'renderer/utils/analytics';

export const useListAnalytics = (items: CarouselItem[], listContext?: ListContext) => {
  const { trackEvent } = useAnalytics();

  const trackSelect = (lineNumber: string) => {
    const found = findItem(items, lineNumber);
    if (!found) return;
    trackEvent(buildEvent('select_item', found.item, found.index, listContext));
  };

  const trackView = (lineNumber: string) => {
    const found = findItem(items, lineNumber);
    if (!found) return;
    trackEvent(buildEvent('view_item_list', found.item, found.index, listContext));
  };

  return { trackSelect, trackView };
};
